<!-- src/views/ContactUs.vue -->
<template>
  <v-container class="pa-4 contact-container">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card class="contact-card">
          <v-card-title>Contact Us</v-card-title>
          <v-card-text>
            Kassandra Jo Tomaras is represented by Rach Crawford at Wolf
            Literary Services. For all inquiries, please contact rachel (at)
            wolflit (dot) com.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, reactive } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";

const router = useRouter();
const form = reactive({ name: "", email: "", message: "" });
const valid = ref(false);
const loading = ref(false);
const contactForm = ref(null);

// define in .env: VITE_CONTACT_API_URL=...
const apiUrl =
  "https://q57uglolfi7xki44gubvmfbcoa0ozmgv.lambda-url.us-east-1.on.aws/";

async function submit() {
  if (!contactForm.value.validate()) return;

  loading.value = true;
  try {
    await axios.post(apiUrl, form);
    alert("Thanks! Your message has been sent.");
    router.push("/");
    form.name = form.email = form.message = "";
    contactForm.value.resetValidation();
  } catch (err) {
    console.error(err);
    alert("Oops—something went wrong sending your message.");
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
/* container: Cream background + extra top padding */
.contact-container {
  background-color: #f0e6d2;
  padding-top: 3rem;
}

/* card: white contrast, warm gray border, soft shadow, spacing */
.contact-card {
  margin-top: 1.5rem;
  background-color: #ffffff !important;
  border: 1px solid #cac4c3;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* card title in Lilac */
.contact-card .v-card-title {
  color: #c8a2c8;
}

/* extra spacing between title and fields */
.contact-card .v-card-text {
  padding-top: 1.5rem;
}

/* form fields: Warm Gray outline, Lilac on focus, Charcoal text/labels */
.theme-input .v-field__outline {
  border-color: #cac4c3 !important;
}
.theme-input.v-input--is-focused .v-field__outline {
  border-color: #c8a2c8 !important;
}
.theme-input .v-label {
  color: #3e3e3e !important;
}
.theme-input input,
.theme-input textarea {
  color: #3e3e3e;
}

/* submit button: Lilac base, Sage hover, Charcoal text */
.submit-button {
  background-color: #c8a2c8 !important;
  color: #3e3e3e !important;
  text-transform: none;
}
.submit-button:hover {
  background-color: #a3b18a !important;
}
</style>
